var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="notification"data-bind="css: css"><!-- ko if: template --> <div class="notification-body"data-bind="template: template"></div><!-- /ko --><!-- ko if: component --> <div class="notification-body"data-bind="component: component"></div><!-- /ko --><!-- ko if: dismissibleByUser --> <button type="button"class="notification-dismiss-button"data-bind="click: function () { $parent.remove($data); }"></button><!-- /ko --> </div>';
}
return __p;
};
